import { YoutubeBroadcast, YoutubeBroadcastVideo } from '../../youtube-broadcast-types';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { Box, SxProps } from '@mui/material';

interface YoutubeBroadcastThumbnailProps {
  video: YoutubeBroadcastVideo;
  /** Pixel width, or omitted to fill the container width. */
  width?: number;
  height?: number;
  sx?: SxProps;
}

/** 16:9 thumbnail image box used in list rows and panorama cards. */
export function YoutubeBroadcastThumbnail({
  video,
  width,
  height,
  sx,
}: YoutubeBroadcastThumbnailProps) {
  const hasThumbnail = Boolean(video.thumbnailUrl);

  return (
    <Box
      sx={{
        width: width ?? '100%',
        height: height ?? 'auto',
        aspectRatio: height ? undefined : '16/9',
        overflow: 'hidden',
        bgcolor: 'action.hover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        ...sx,
      }}
    >
      {hasThumbnail ? (
        <Box
          component="img"
          src={video.thumbnailUrl}
          alt={video.title}
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        <PlayArrowIcon color="disabled" />
      )}
    </Box>
  );
}
